/* eslint-disable no-undef */
import LocalStorage from "./LocalStorage";
import SessionStorage from "./SessionStorage";
import { AppEnvs, AppStorageKeys, DefaultTablePageSize } from "./Constants";

export const defaultSort = (a, b) => {
  if (!!a && !!b) {
    return a.localeCompare(b);
  } else if (!!a) {
    return -1;
  } else if (!!b) {
    return 1;
  }
  return 0;
};
export const dateSort = (a, b) => moment(a).unix() - moment(b).unix();

export const createFilter = (options) => {
  return Object.values(options).map((a) => {
    return { text: a.label, value: a.value };
  });
};

export const selectAdvanceFilterFunction = (searchBy) => (input, option) => {
  return option[searchBy]?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};
export const selectFilterFunction = selectAdvanceFilterFunction("children");

export const getCurrentUserFromStorage = () => {
  return (
    LocalStorage.get(AppStorageKeys.currentUser) ||
    SessionStorage.get(AppStorageKeys.currentUser)
  );
};

export const getRedirectQueryParams = ({
  path,
  prov,
  part,
  model,
  defaultProvider,
}) => {
  const currentUser = getCurrentUserFromStorage();
  const { username, access_token } = currentUser;
  return `user=${username}&prov=${prov}&part=${part}&path=${path}&env=${
    AppEnvs.HA
  }${model ? "&model=" + model : ""}&tok=${encodeURIComponent(access_token)}${
    defaultProvider ? "&defaultProvider=" + defaultProvider : ""
  }`;
};

export const jsonValidator =
  ({ type = "object" } = {}) =>
  async (_, value) => {
    if (!!value) {
      try {
        const object = JSON.parse(value);
        if (type) {
          if (type === "array" && !Array.isArray(object)) {
            return Promise.reject(new Error("Must be JSON array"));
          }
        }
      } catch (error) {
        return Promise.reject(new Error("Invalid JSON format"));
      }
    }
  };

export const setTablePageSize = (pageKey, size) => {
  const current_user = getCurrentUserFromStorage();
  const base_key = `${current_user?.username}`;
  let pageHistory = LocalStorage.get(base_key);
  pageHistory
    ? (pageHistory[pageKey] = size)
    : (pageHistory = { [`${pageKey}`]: `${size}` });
  LocalStorage.set(base_key, pageHistory);
};

export const getTablePagesize = (pageKey) => {
  const current_user = getCurrentUserFromStorage();
  const base_key = `${current_user?.username}`;
  const userPage = LocalStorage.get(base_key) || {};
  const tableSize = userPage[pageKey] || DefaultTablePageSize;
  return tableSize;
};
